/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SegnalazioneAccountForm { 
    access_token: string;
    nome: string;
    cognome: string;
    telefono: string;
    email?: string;
    testo_segnalazione: string;
}

